import { FC } from 'react';
import { Navigate } from 'react-router-dom';

// SigninPage is here for legacy reasons, but it is not actually used in the rest of the code
// since authentication and redirects are managed in ProtectedLayer
// so it just redirects to frontpage, if resources is protected it will be managed with ProtectedLayer

const SigninPage: FC = () => {
  const pathname = import.meta.env.VITE_USER_FRONTPAGE;
  return <Navigate to={pathname} />;
};

export default SigninPage;
